<template>
  <div class="miya-inviteReward">
    <el-scrollbar style="height:100%;">
      <div class="pageBox">
        <h1 class="title1 fontSH">{{$t('menu.m7')}}</h1>
        <div class="page-content">
          <div class="left-card">
            <div class="usdt-card">
              <div class="bg"></div>
              <div class="border"></div>
              <div class="cardName">
                <span class="name">{{$t('reward.cardName')}}</span>
                <img class="img" src="@/assets/images/inviteReward/cardName.png">
              </div>
              <div class="amount">
                <p class="text">{{usdtReward}}<span class="unit">USDT</span></p>
              </div>
              <p class="tipText">[ {{$t('reward.tipText')}} ]</p>
              <div class="btns">
                <div class="btn btn1" :class="{disabled: usdtReward < 20}" @click.stop="clickBtn1()">{{$t('reward.btn1')}}</div>
                <div class="btn2" @click.stop="clickBtn2()">{{$t('reward.btn2')}}</div>
              </div>
            </div>
            <h1 class="title2">{{$t('reward.title2')}}</h1>
            <h2 class="title3">{{$t('reward.subtitle2')}}</h2>
            <p class="title4">{{$t('reward.text1')}}<span class="red">{{$t('reward.text2')}}</span>{{$t('reward.text3')}}<span class="red">{{$t('reward.text4')}}</span>{{$t('reward.text5')}}</p>
            <div class="copyBtns">
              <div class="item">
                <el-button type="primary" class="btn-copy copyBtn1" size="medium" :data-clipboard-text="user.inviteCode" @click="clickCopye('copyBtn1')">{{$t('reward.copyBtn1')}}</el-button>
                <el-input class="textarea" :rows="4" type="textarea" :disabled="true" v-model="user.inviteCode" :placeholder="$t('login.inviteCode')"></el-input>
              </div>
              <div class="item">
                <el-button type="primary" class="btn-copy copyBtn2" size="medium" :data-clipboard-text="inviteCode2" @click="clickCopye('copyBtn2')">{{$t('reward.copyBtn2')}}</el-button>
                <el-input class="textarea" :rows="4" type="textarea" :disabled="true" v-model="inviteCode2" :placeholder="$t('reward.placeholder2')"></el-input>
              </div>
            </div>
            <p class="title4"><span class="red">{{$t('reward.text6')}}</span></p>
          </div> 
          <div class="right-table">
            <div class="table-title-box">
              <h2 class="title2">{{$t('reward.title3')}}<span class="tip">{{$t('reward.text7')}}</span></h2>
              <div class="table-data">
                <el-table ref="multipleTable" v-loading="tableLoading" :max-height="600" :data="tableData" style="width: 100%">
                  <el-table-column prop="id" :label="$t('reward.tTitle1')" show-overflow-tooltip min-width="70">
                  </el-table-column>
                  <el-table-column prop="account" :label="$t('reward.tTitle2')" show-overflow-tooltip min-width="60">
                  </el-table-column>
                  <el-table-column prop="usdt" :label="$t('reward.tTitle3')" show-overflow-tooltip min-width="90">
                  </el-table-column>
                  <el-table-column prop="createTime" :label="$t('reward.tTitle4')" show-overflow-tooltip min-width="80">
                    <template slot-scope="scope">
                      <span>{{scope.row.createTime ? scope.row.createTime : '--'}}</span>
                    </template>
                  </el-table-column>
                  <div slot="empty" class="table_nodata">
                    <img v-if="!tableLoading" class="nodata" src="@/assets/images/home/noData.png" height="240" alt="" />
                    <p v-if="!tableLoading" class="nodataText">{{$t('home.noData')}}</p>
                  </div>
                </el-table>
              </div>
            </div>
            <div class="pagination-box">
              <div class="selection"> 
              </div>
              <div class="pagination">
                <el-pagination size="medium" :layout="pageWidth < 800 ? 'total,prev, pager, next' : 'total, sizes, prev, pager, next'" :page-sizes="[8,20,30,50]" :page-size="pageSize" :current-page="page" :pager-count="5" :total="total" @size-change='changeDataSize'  @current-change='changePage'></el-pagination>
              </div> 
            </div>
          </div>
          <el-dialog :title="$t('pTraffic.contactTitle')" :visible.sync="dialogTableContact" width="300px">
            <img class="contactVx" src="@assets/images/login/vx.png">
          </el-dialog>
        </div>
      </div> 
    </el-scrollbar>
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  data () {
    return {
      tableData: [],
      tableLoading: false,
      page: 1,
      pageSize: 8,
      total: 0,
      dialogTableContact: false,
    }
  },
  computed: {
    usdtReward () {
      return Number(this.user.usdtReward) || 0
    },
    inviteCode2 () {
      return `${window.hostUrl}signup?invitecode=${this.user.inviteCode}`
    },
    ...mapGetters(['user'])
  },
  created () {
    this.getDataList()
  },
  mounted () {  
    this.getData()
  },
  methods: {
    getData () {
    },
    getDataList () {
      this.tableLoading = true
      this.$get(`/InviteHistory/Load?page=${this.page}&limit=${this.pageSize}`).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.tableData = res.data
          this.total = res.count
        }
      })
    },
    changeDataSize (pageSize) {
      this.page = 1
      this.pageSize = pageSize
      this.getDataList()
    },
    changePage (page) {
      this.page = page
      this.getDataList()
    },
    clickCopye (btn) {
      var clipboard = new this.Clipboard(`.${btn}`)
      clipboard.on('success', () => {
        this.$message.success(this.$t('reward.copySuccess'))
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.$message.error(this.$t('reward.copyError'))
        clipboard.destroy()
      })
    },
    clickBtn1 () { // 提现
      if (this.usdtReward < 20) {
        this.$message.error(this.$t('reward.tipText'))
        return
      } else {
        this.dialogTableContact = true
      }
    },
    clickBtn2 () { // 赚到USDT余额
      this.$get(`/InviteHistory/TrsToUsdt`).then(res => {
        if (res.code === 200) {
          this.$message.success(res.message)
        } else if (res.code === 500) {
          this.$message.error(res.message)
        }
      })
    },
  },
  beforeDestroy () {
  },
  watch: {
    language () {
      this.getData()
    },
  },
  components: {}
}
</script>
<style scoped lang="stylus">
.miya-inviteReward
  height 100%
  overflow-y hidden
  .pageBox
    min-height 100%
    padding 40px 40px 24px 40px
    position relative
  .title1
    color $c1
    font-size 28px
    margin 10px 0 32px 0
  .title2
    color $c8
    font-size $f20
    margin-bottom 32px
    font-weight 300
    .tip
      margin-left 16px
      color $c2
      font-size $f14
      font-weight 300
  .title3
    color $c1
    font-size $f16
    margin-bottom 12px
  .title4
    font-size $f14
    color $c1
    line-height 22px
    .red
      color $c10
  .page-content
    display flex
    .left-card
      width 40%
      margin-right 56px
      .usdt-card
        height 240px
        background: linear-gradient(45deg, $c5 0%,  $c2 100%)
        border-radius 12px
        position relative
        padding-top 50px
        box-shadow 0 14px 20px rgba(20, 17, 14, 0.16)
        margin-bottom 56px
        .border, .bg
          border-radius 9px
          position absolute
          top 4px
          left 4px
          width calc(100% - 8px)
          height calc(100% - 8px)
        .border
          z-index 1
          background: linear-gradient(45deg, #4E4A45 0%,  #271E14 100%)
        .bg
          background-image url('../../assets/images/inviteReward/card-bg.png')
          background-size cover
          opacity 0.4
          z-index 2
        .cardName
          position absolute
          top -15px
          left 13px
          z-index 4
          .img
            width 172px
          .name
            position absolute
            color $c7
            width 100%
            fontWeight()
            text-align center
            top 26%
        .amount
          text-align center
          width 100%
          line-height 40px
          position relative
          z-index 4
          .text
            font-size 40px
            fontWeight()
            color $c8
            text-shadow 2px 3px 5px $c1
            .unit
              font-size $f12
              font-weight 300
              text-shadow none
              margin-left 6px
        .tipText
          font-size $f14
          color $c4
          text-align center
          position relative
          z-index 4
        .btns
          position absolute
          bottom 20px
          left 32px
          right 32px
          z-index 4
          .btn
            line-height 36px
            text-align center
            font-size $f14
            color $c7
            background-image url('../../assets/images/inviteReward/btn2.png')
            background-size 100% 100%
            cursor pointer
            box-shadow 0 4px 6px $c1
            &:hover
              box-shadow 0 12px 12px rgba(20, 17, 14, 0.6)
          .btn1
            margin 0 auto
            margin-bottom 12px
          .disabled
            background-image url('../../assets/images/inviteReward/btn1.png')
            background-size 100% 100%
            cursor not-allowed
            box-shadow none 
            &:hover
              box-shadow none 
          .btn2
            text-align center
            cursor pointer
            color $c7
            line-height 18px
            &:hover
              color $c8
      .copyBtns
        margin 32px 0
        .item
          display flex
          .btn-copy
            width 160px
            margin-right 12px
            height 36px
            border-radius 0
            padding 10px
          .textarea
            flex 1
          &:nth-of-type(1)
            margin-bottom 24px
    .right-table
      flex 1
      overflow hidden
      .table-title-box
        background-color #F7F7F7
        padding 16px 24px 0 24px
      .table-data
        margin-top 32px
        min-height 600px
    .pagination-box
      background-color $c7
      padding 10px 20px
      border 1px solid $c4
      display flex
      .selection
        flex 1
  .contactVx
    display block
    margin 0 auto
@media screen and (max-width: 1440px)
  .miya-inviteReward
    .page-content
      .left-card
        margin-right 20px
@media screen and (max-width: 800px)
  .miya-inviteReward
    overflow-y auto
    .title1
      margin-bottom 1rem
      line-height 1.5rem  
    .title2
      margin-bottom 1rem
    .page-content
      display block
      .left-card, .right-table
        width 100%
      .left-card
        margin-right 0
        .usdt-card
          margin-bottom 1rem
        .copyBtns
          margin 1rem 0
          .item
            display block
            .btn-copy
              width 100%
      .right-table
        .table-title-box
          padding 0.5rem 0
          margin-top 1rem
        .table-data
          margin-top 1rem
          min-height 12rem
</style>
<style lang="stylus">
.miya-inviteReward
  .el-button--primary
    background: linear-gradient(95deg, #FF8F10 0%, #FF7010 100%)
  .el-table th.el-table__cell
    background-color #EBEBEB
  .el-table tr
    background-color #F7F7F7
  .el-table .cell
    padding-left 8px
    padding-right 8px
  .el-textarea.is-disabled .el-textarea__inner
    color $c1
  .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell
    background-color #F0F0F0
</style>